import { OutboundSMS } from '@missionlabs/types'
import { BaseQueryFn } from '@reduxjs/toolkit/dist/query'

import { customCreateApi } from './customCreateAPI'

export const buildSMSAPI = (baseQuery: BaseQueryFn) => {
    const api = customCreateApi({
        reducerPath: 'messagingAPI',
        baseQuery,
        endpoints: builder => ({
            sendMessage: builder.mutation<void, OutboundSMS>({
                query: payload => {
                    return {
                        url: `/messaging/sms/clients/:clientID/users/:userID/messages`,
                        method: 'POST',
                        body: {
                            ...payload,
                            type: 'text'
                        }
                    }
                }
            })
        })
    })

    return { api, ...api }
}
